import {AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";
import {VisitorTypeDto} from "../dto/VisitorTypeDto";

export const VisitorTypeApi = {
    /**
     * 获得场所列表
     */
    getVisitorTypeList: async () => {
        try {
            const requestUrl = '/v1/vms/visitor/type/list';
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getVisitorTypeDetail: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visitor/type/detail', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createVisitorType: async (body: VisitorTypeDto) => {
        try {
            const requestUrl = '/v1/vms/visitor/type/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    updateVisitorType: async (body: VisitorTypeDto) => {
        try {
            const requestUrl = '/v1/vms/visitor/type/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteVisitorType: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/vms/visitor/type/delete', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
